import { get, put, post, del } from '@/libs/api.request'

export default {
  state: {
    componentSubstitutions: {},
    componentSubstituteParents: {}
  },
  getters: {
    componentSubstitions: state => {
      return state.componentSubstitutions
    }
  },
  mutations: {
    //  Store component and its substitutions components ralationship
    setComponentSubstitutions(state, mpId, substitions) {
      let newObj = {}
      newObj[mpId] = substitions
      let merged = _.merge(state.componentSubstitutions, newObj)
      state.componentSubstitutions = Object.assign({}, merged)
    },
    setComponentSubstitutionMulti(state, substitionsMultiResult) {
      function customizer(objValue, srcValue) {
        if (_.isArray(objValue)) {
          return _.unionBy(_.concat(objValue, srcValue), 'id')
        }
      }
      let merged = _.mergeWith(state.componentSubstitutions, substitionsMultiResult, customizer)
      state.componentSubstitutions = Object.assign({}, merged)
    },
    setComponentSubstituteParents(state, mpId, substiteParents) {
      state.componentSubstituteParents[mpId] = substiteParents
    }
  },
  actions: {
    loadComponentSubstitutions ({ commit, state }, mpId, refresh = true) {
      return new Promise((resolve, reject) => {
        if (state.componentSubstitutions &&
          !_.isEmpty(state.componentSubstitutions) &&
          (state.componentSubstitutions[mpId] && !refresh)) {
          resolve(state.componentSubstitutions[mpId])
        } else {
          get(`parts/${mpId}/substitutions`).then(res => {
            commit('setComponentSubstitutions', mpId, res.data)
            resolve(res.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    loadComponentSubstitutionsMulti ({ commit, state }, { ids, include_self }) {
      return get(`parts/multi/substitutions`, { ids: ids, include_self }).then(res => {
        commit('setComponentSubstitutionMulti', res.data)
        return res.data
      })
    },
    loadComponentSubstituteParents ({ commit, state }, mpId, refresh = true) {
      return new Promise((resolve, reject) => {
        if (state.componentSubstituteParents &&
          !_.isEmpty(state.componentSubstituteParents) &&
          (state.componentSubstituteParents[mpId] && !refresh)) {
          resolve(state.componentSubstituteParents[mpId])
        } else {
          get(`parts/${mpId}/substitute-parents`).then(res => {
            commit('setComponentSubstituteParents', mpId, res.data)
            resolve(res.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    getComponentSubstitutionList ({ commit }, data) {
      return get(`parts/substitutions/list`, data).then(res => {
        return res.data
      })
    },
    getComponentSubstitution ({ commit }, id) {
      return get(`parts/substitutions/${id}`).then(res => {
        return res.data
      })
    },
    addToComponentSubstitution ({ commit }, { id, component_id, base_component_id }) {
      return post(`parts/${base_component_id}/substitutions/${id}/add-items`, { component_id }).then(res => {
        return res.data
      })
    },
    removeFromComponentSubstitution ({ commit }, { id, component_ids }) {
      return post(`parts/substitutions/${id}/remove-items`, { component_ids }).then(res => {
        return res.data
      })
    },
    removeComponentSubstitutionByPartId ({ commit }, { id, component_ids }) {
      return post(`parts/${id}/substitutions/remove-items`, { component_ids }).then(res => {
        return res.data
      })
    },
    updateComponentSubstitution ({ commit }, data) {
      return put(`parts/substitutions/${data.id}`, data).then(res => {
        return res.data
      })
    },
    createComponentSubstitution ({ commit }, data) {
      return post(`parts/substitutions`, data).then(res => {
        return res.data
      })
    },
    deleteComponentSubstitution ({ commit }, id) {
      return del(`parts/substitutions/${id}`)
    }
  }
}
